export default __webpack_public_path__ + "static/media/abid7.12724c51.png";